// src/components/chat/ChatInput.jsx
import React from 'react';
import { Send, Mic, MicOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ChatInput = (props) => {
  const { t } = useTranslation();
  const {
    input = '',
    setInput,
    handleSend,
    isLoading = false,
    inputRef,
    isListening = false,
    toggleVoice,
    recognition,
    disabled = false
  } = props;

  // === 100% protection against undefined ===
  const isInputValid = input && typeof input === 'string' && input.trim().length > 0;

  return (
    <div className="bg-white border-t border-gray-200 p-4 md:p-6">
      <div className="max-w-[80rem] mx-auto">
        <div className="flex gap-3 items-center">
          {/* Input field */}
          <input
            ref={inputRef}
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && !e.shiftKey && handleSend()}
            placeholder={isListening ? t('chatbot.input.placeholder.listening') : t('chatbot.input.placeholder.default')}
            className="flex-1 p-4 rounded-xl border-2 border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 bg-gray-50 placeholder-gray-500 text-sm ai-input"
            disabled={isLoading || isListening || disabled}
          />

          {/* Microphone button */}
          <button
            onClick={toggleVoice}
            disabled={!recognition || isLoading || disabled}
            className={`
        p-4 rounded-xl transition-all duration-200 cursor-pointer
        ${isListening
                ? "bg-red-500 text-white animate-pulse shadow-lg"
                : recognition
                  ? "bg-blue-100 text-blue-600 hover:bg-blue-200 hover:shadow-md"
                  : "bg-gray-100 text-gray-400 opacity-60"
              }
    `}
            title={recognition ? (isListening ? t('chatbot.input.voice.stop') : t('chatbot.input.voice.speak')) : t('chatbot.input.voice.not_supported')}
          >
            {isListening ? (
              <MicOff className="w-5 h-5" />
            ) : (
              <Mic className="w-5 h-5" />
            )}
          </button>

          {/* Send button  */}
          <button
            onClick={handleSend}
            disabled={!isInputValid || isLoading || disabled}
            className="px-6 py-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-xl font-medium hover:from-blue-700 hover:to-indigo-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:scale-105 hover:shadow-lg flex items-center gap-2"
          >
            <Send className="w-4 h-4" />
            {t('chatbot.input.send')}
          </button>
        </div>

        <div className="mt-3 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500">
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
            {t('chatbot.input.disclaimer.general')}
          </div>
          <span className="hidden sm:inline">•</span>
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 bg-red-500 rounded-full"></div>
            {t('chatbot.input.disclaimer.not_legal')}
          </div>
          <span className="hidden sm:inline">•</span>
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            {t('chatbot.input.disclaimer.consult')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;